import { defineMessages } from 'react-intl-next';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-customer-org.customer-org-label',
		defaultMessage: 'Customer Organization',
		description: 'Customer Organization subtype label',
	},
});
